import {Injectable} from '@angular/core';
import {EDevicePermissions, EDevicePermissionState} from '../../models/device-permissions.enum';
import {DEFAULT_DEVICE_PERMISSIONS, IDevicePermissions, IDeviceUserAgent} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class UserDeviceAndPermissionService {

  getUserAgentAndDeviceType(): IDeviceUserAgent {
    return {
      isDeviceUserAgentLoading: true,
      isMobile: !!this.isDeviceMobile() === true,
      userAgent: navigator.userAgent.toLowerCase(),
    };
  }

  isDeviceMobile(): boolean {
    const ua = navigator.userAgent.toLowerCase();
    const isTouch =
      'ontouchstart' in window ||
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
    return /android|iphone|ipad|ipod|iemobile|wpdesktop/i.test(ua) || isTouch;
  }

  async queryDevicePermission(name: EDevicePermissions): Promise<EDevicePermissionState | null> {
    try {
      if ('permissions' in navigator && navigator?.permissions?.query) {
        const result: PermissionStatus = await navigator.permissions.query({name: name as PermissionName});
        return <EDevicePermissionState>result.state;
      } else {
        return <EDevicePermissionState>EDevicePermissionState.notSupported;
      }
    } catch (error) {
      console.error(`Permission check for "${name}" failed:`, error);
      return <EDevicePermissionState>EDevicePermissionState.error;
    }
  }

  async queryDevicePermissions(): Promise<IDevicePermissions | null> {
    try {
      const permissions: IDevicePermissions = {...DEFAULT_DEVICE_PERMISSIONS};
      if ('permissions' in navigator && navigator?.permissions?.query) {
        for (const permissionName of Object.values(EDevicePermissions)) {
          const query: PermissionStatus = await navigator.permissions.query({name: permissionName as PermissionName});
          permissions[permissionName] = query.state as EDevicePermissionState;
        }
      }
      return permissions;
    } catch (error) {
      return DEFAULT_DEVICE_PERMISSIONS;
    }
  }


}
